import styled, { css } from 'styled-components';
export var Block = styled.div.withConfig({
  displayName: "partials__Block",
  componentId: "sc-19b9hiu-0"
})(["display:flex;align-items:center;flex-direction:column;justify-content:center;height:100%;min-height:113px;padding:10px 20px;border:1px solid #eee;border-radius:", ";cursor:pointer;background-color:", ";text-align:center;&:hover{background-color:#eee;}", ""], function (_ref) {
  var theme = _ref.theme;
  return "".concat(theme.borderRadius);
}, function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.cardsBackgroundColor);
}, function (props) {
  return props.empty && css(["display:flex;flex-flow:column;justify-content:center;text-align:center;"]);
});
export var CircleContainer = styled.div.withConfig({
  displayName: "partials__CircleContainer",
  componentId: "sc-19b9hiu-1"
})(["padding-top:10px;text-align:center;"]);
export var Circle = styled.div.withConfig({
  displayName: "partials__Circle",
  componentId: "sc-19b9hiu-2"
})(["display:inline-block;width:", ";height:", ";border-radius:", ";", ";", ""], function (props) {
  return "".concat(2 * props.radius, "px");
}, function (props) {
  return "".concat(2 * props.radius, "px");
}, function (props) {
  return "".concat(props.radius, "px");
}, function (_ref3) {
  var horizontal = _ref3.horizontal;
  return horizontal && css(["width:30px;height:6px;"]);
}, function (props) {
  return props.color && "background-color: ".concat(props.color, ";");
});